export default {
	"scanPay.FailedToGenerateOrder": "生成訂單失敗",
	"scanPay.paymentSuccessful": "支付成功",
	"scanPay.Purchases": "購買商品：",
	"scanPay.OrderNumber": "訂單編號：",
	"scanPay.TheAmountActuallyPaid": "實付金額："
}